import type { Chord } from 'svguitar';

export const CSustChords: Record<string, Chord> = {
  'C#': {
    fingers: [
      [2, 4, '4'],
      [3, 4, '3'],
      [4, 4, '2'],
      [6, 'x'],
    ],
    barres: [
      {
        fromString: 5,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'C#',
    position: 2,
  },
  'C#9': {
    fingers: [
      [3, 4, '4'],
      [4, 4, '3'],
      [6, 'x'],
    ],
    barres: [
      {
        fromString: 5,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'C#9',
    position: 2,
  },
  'C#m': {
    fingers: [
      [2, 3, '2'],
      [3, 4, '4'],
      [4, 4, '3'],
      [6, 'x'],
    ],
    barres: [
      {
        fromString: 5,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'C#m',
    position: 2,
  },
  'C#m7': {
    fingers: [
      [2, 3, '2'],
      [4, 4, '3'],
      [6, 'x'],
    ],
    barres: [
      {
        fromString: 5,
        toString: 1,
        fret: 2,
        text: '1',
        color: '#0F0',
        textColor: '#F00',
      },
    ],
    title: 'C#m7',
    position: 2,
  },
};
